@if (detailMode()) {
<!-- Mobile Overlay - shown when sidebar is open on mobile -->
<div 
  class="mobile-overlay" 
  [class.visible]="isMobileSidebarVisible()"
  (click)="closeMobileSidebar()">
</div>

<aside class="sidebar" [class.collapsed]="isCollapsed()" [class.detail-mode]="detailMode()" [class.mobile-visible]="isMobileSidebarVisible()">
  <div class="detail-content">
    <div class="detail-top">
      <div class="detail-claim-header">
        <div class="avatar-circle">
          <i class="pi pi-car"></i>
        </div>
        <div class="claim-numbers">
          <div class="claim-number">{{ detailPageInfo()?.claimNumber }}</div>
          <div class="claim-id">{{ detailPageInfo()?.claimSequence }}</div>
        </div>
      </div>
      <div class="action-buttons">
        <button class="sidebar-action-btn primary btn-action-orange" title="Assignment Actions" (click)="openDispatchActions()">
          <i class="pi pi-cog"></i>
          <span class="btn-text">Assignment Actions</span>
        </button>
        <button class="sidebar-action-btn print" title="Print Assgn Sheet" (click)="handlePrintClick()">
          <i class="pi pi-print"></i>
          <span class="btn-text">Print Assgn Sheet</span>
        </button>
      </div>
    </div>
    <div class="detail-menu">
      @for (item of detailMenu; track item.label) {
        @if (!item.hidden) {
        <!-- Show level 1 items and level 2 items only if not hidden -->
        <button
          class="detail-menu-item"
          [class.active]="isDetailMenuActive(item)"
          [class.submenu-item]="item.level === 2"
          [class.pending-disabled]="isMenuItemDisabled(item)"
          [title]="menuItemTitle(item)"
          (click)="handleDetailMenuClick(item)">
          <i [class]="item.icon" class="menu-icon-left"></i>
          <span class="menu-label">{{ item.label }}</span>
          <!-- Warning triangle for tabs with missing mandatory fields -->
          @if (getMissingFieldsIcon(item); as iconColor) {
            <i class="pi pi-exclamation-triangle warning-triangle"
               [class.warning-triangle--black]="iconColor === 'black'"
               [class.warning-triangle--yellow]="iconColor === 'yellow'"></i>
          }
          <!-- Show expand icon for items with submenu -->
          @if (item.hasSubmenu) {
          <i [class]="item.expanded ? 'pi pi-angle-up' : 'pi pi-angle-down'" class="menu-icon-right"></i>
          }
        </button>
        }
      }
    </div>
  </div>
    <button class="fab" (click)="toggleSidebar()">
    <i class="pi" [ngClass]="{
        'pi-angle-double-left': !isCollapsed(),
        'pi-angle-double-right': isCollapsed()
      }"></i>
  </button>
  <div class="version">
    <p>{{ version() }}</p>
    @if (buildTimestamp()) {
      <p class="build-timestamp">{{ buildTimestamp() | date:'MM/dd/yy hh:mm a' }}</p>
    }
  </div>

  <!-- Dispatch Actions Drawer -->
  <app-dispatch-actions-drawer
    [(visible)]="dispatchActionsVisible"
    [config]="dispatchActionsConfig()">
  </app-dispatch-actions-drawer>
</aside>
} @else {
  <!-- Mobile Overlay - shown when sidebar is open on mobile -->
  <div 
    class="mobile-overlay" 
    [class.visible]="isMobileSidebarVisible()"
    (click)="closeMobileSidebar()">
  </div>
  
  <aside class="sidebar" [class.collapsed]="isCollapsed()" [class.mobile-visible]="isMobileSidebarVisible()">
    <!-- Mobile Title Header -->
    <div class="mobile-sidebar-header">
      <h1 class="mobile-sidebar-title">eDispatch</h1>
    </div>
    
    <!-- Menu Items -->
    <div class="flex flex-col w-full flex-1 min-h-0 overflow-y-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      <div class="flex flex-col w-full">
        @for (item of menuItems; track item.label) {
          <button 
            [class.active]="item.active"
            class="menu-item"
            (click)="handleMenuClick(item)"
            [routerLink]="!item.external ? item.route : null"
            [title]="item.label === 'Maps' && !detailPageInfo()?.appointmentId ? 'Open Maps from an assignment detail' : item.label"
            >
            <div class="icon-wrapper">
              <i [class]="item.icon"></i>
            </div>
            <p class="btn-text">
              {{ item.label }}
            </p>
          </button>
        }
      </div>
    </div>
    <button class="fab" (click)="toggleSidebar()">
      <i class="pi" [ngClass]="{
          'pi-angle-double-left': !isCollapsed(),
          'pi-angle-double-right': isCollapsed()
        }"></i>
    </button>
    <div class="version">
      <p>{{ version() }}</p>
      @if (buildTimestamp()) {
        <p class="build-timestamp">{{ buildTimestamp() | date:'MM/dd/yy hh:mm a' }}</p>
      }
    </div>
  </aside>
}
